import { BaseTranslation } from 'src/i18n/i18n-types';

export const organisations: BaseTranslation = {
  switcher: {
    title: 'Switch Active Workspace',
    alreadyActive: 'Workspace already active',
    success: 'Successfully switched workspaces',
    error: 'Something went wrong while switching workspaces. Please try again.',
  },
  invitation: {
    loading: 'Loading invitation...',
    title: "You've been invited to join",
    description:
      'Accept the invitation to start working with {organisationName} to create winning ads.',
    userInOrgDescription:
      'Great news, you are already a part of {organisationName}. Do you want to switch over?',
    accept: 'Accept Invitation',
    switch: 'Switch Organisation',
    success: "You have joined {organisationName}'s organisation",
    error:
      "Something went wrong while joining {organisationName}'s organisation: {message}",
    invitedUser: 'Successfully invited user',
    invitedMultipleUsers: 'Successfully invited users',
  },
};
